'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = TagCommander;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _tagCommander = require('./utils/tag-commander');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function TagCommander(WrappedComponent, tagCommanderParams) {
  var _class, _temp;

  if (typeof tagCommanderParams !== 'function') {
    throw new Error('Expected tagCommanderParams to be an function not ' + (typeof tagCommanderParams === 'undefined' ? 'undefined' : _typeof(tagCommanderParams)));
  }

  return _temp = _class = function (_Component) {
    _inherits(TagCommanderHOC, _Component);

    function TagCommanderHOC() {
      _classCallCheck(this, TagCommanderHOC);

      return _possibleConstructorReturn(this, (TagCommanderHOC.__proto__ || Object.getPrototypeOf(TagCommanderHOC)).apply(this, arguments));
    }

    _createClass(TagCommanderHOC, [{
      key: 'sendActions',
      value: function sendActions(actionParams) {
        var params = actionParams;
        if (!Array.isArray(params)) {
          params = [params];
        }

        params.forEach(function (param) {
          (0, _tagCommander.queueEvent)(null, param.id, param.data);
        });
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.sendActions(tagCommanderParams(this.context.store.getState()));
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(WrappedComponent, this.props);
      }
    }]);

    return TagCommanderHOC;
  }(_react.Component), _class.contextTypes = {
    store: _react.PropTypes.object
  }, _temp;
}


//////////////////
// WEBPACK FOOTER
// ./~/@axa-asia/hk-tag-commander/lib/TagCommander.js
// module id = 819
// module chunks = 0